// 'use client'
// import { sendGAEvent } from '@next/third-parties/google'
// import Image from 'next/image'
// import Link from 'next/link'
// import { useRouter } from 'next/navigation'
// import { useEffect, useState } from 'react'
// import { useDetectClickOutside } from 'react-detect-click-outside'
// import Masonry from 'react-masonry-css'
// import { useDispatch } from 'react-redux'
// import {
//   getUserId,
//   getUserToken,
//   reactImageUrl,
//   spaceToDash
// } from '../lib/GetBaseUrl'
// import { _subMenuImg_ } from '../lib/ImagePath'
// import { checkTokenAuthentication } from '../lib/checkTokenAuthentication'
// import { handleLogout } from '../lib/handleLogout'
// import LoginSignup from './auth/LoginSignup'
// import MBtn from './base/MBtn'

// const HeaderMenu = ({ categoryMenu, user, isloaded }) => {
//   const userIdCookie = getUserId()
//   const router = useRouter()
//   const dispatch = useDispatch()
//   const [isOpen, setIsOpen] = useState(false)
//   const [activeSubmenus, setActiveSubmenus] = useState([])
//   const [thirdSubmenus, setActivethirdSubmenus] = useState([])
//   const [activeItems, setActiveItems] = useState([])
//   const [modal, setModal] = useState(false)
//   let nav_linkimg = false

//   const breakpointColumnsObj = {
//     default: 4,
//     1024: 1
//   }

//   const setShowModal = () => {
//     setIsOpen(false)
//     if (!user?.userId) {
//       if (userIdCookie) {
//         checkTokenAuthentication(dispatch)
//       } else {
//         setModal(true)
//       }
//     }
//   }

//   const closeModal = () => {
//     setModal(false)
//   }

//   const handleMouseEnter = (index) => {
//     setActiveItems((prevActiveItems) => {
//       const updatedActiveItems = [...prevActiveItems]
//       updatedActiveItems[index] = true
//       return updatedActiveItems
//     })
//   }

//   const handleMouseLeave = (index) => {
//     setActiveItems((prevActiveItems) => {
//       const updatedActiveItems = [...prevActiveItems]
//       updatedActiveItems[index] = false
//       return updatedActiveItems
//     })
//   }

//   const handleClick = (index) => {
//     setActiveItems((prevActiveItems) => {
//       const updatedActiveItems = [...prevActiveItems]
//       updatedActiveItems[index] = false
//       return updatedActiveItems
//     })
//   }

//   const closeMenu = (e) => {
//     const wrapper = document.getElementById('nav_wrapper')

//     if (
//       wrapper?.classList.contains('active') &&
//       (e.target.classList.contains('navmenu_wrapper') ||
//         e.target.classList.contains('m-icon'))
//     ) {
//       setIsOpen(false)
//       setActiveSubmenus(' ')
//       setActivethirdSubmenus(' ')
//       document.body.style.overflow = ''
//     }
//   }

//   const toggleSubmenu = (index) => {
//     if (activeSubmenus.includes(index)) {
//       setActiveSubmenus(activeSubmenus.filter((i) => i !== index))
//     } else {
//       setActiveSubmenus([...activeSubmenus, index])
//     }
//   }

//   const toggleThirdSubmenu = (index) => {
//     if (thirdSubmenus.includes(index)) {
//       setActivethirdSubmenus(thirdSubmenus.filter((i) => i !== index))
//     } else {
//       setActivethirdSubmenus([...thirdSubmenus, index])
//     }
//   }

//   const specificPartRef = useDetectClickOutside({ onTriggered: closeMenu })

//   const checkMenuCase = (card) => {
//     let url = ''
//     switch (card?.redirectTo) {
//       case 'Product List':
//         url = ''
//         if (card?.categoryId) {
//           url += `/products/${spaceToDash(card?.name)}?CategoryId=${
//             card?.categoryId
//           }`
//         }
//         if (card?.brands) {
//           url += `&BrandIds=${card?.brands?.split(',')?.map((item) => item)}`
//         }
//         if (card?.sizes) {
//           url += `&SizeIds=${card?.sizes?.split(',')?.map((item) => item)}`
//         }
//         if (card?.colors) {
//           url += `&ColorIds=${card?.colors?.split(',')?.map((item) => item)}`
//         }
//         break
//       case 'Collection Page':
//         url = `/collection?productCollectionId=${card?.collectionId}`
//         break
//       case 'Brand List':
//         url = `/products/brand/${spaceToDash(card?.name)}?BrandIds=${
//           card?.brandId
//         }`
//         break
//       case 'Static Page':
//         url = `/static?id=${card?.staticPageId}`
//         break
//       case 'Other Links':
//         if (card?.customLink && card.customLink.startsWith('http')) {
//           url = card.customLink
//         } else {
//           url = card?.customLink ? card.customLink : '#.'
//         }
//         break
//       default:
//         url = '#.'
//         break
//     }
//     return url
//   }

//   useEffect(() => {
//     const interval = setInterval(() => {
//       const token = getUserToken()
//       if (token) {
//         clearInterval(interval)
//       }
//     }, 1)
//   }, [])

//   return (
//     <>
//       {modal && <LoginSignup modal={modal} onClose={closeModal} />}

//       <div>
//         <button
//           className="m_toggle"
//           onClick={() => {
//             setIsOpen(() => true)
//             document.body.style.overflow = 'hidden'
//           }}
//         >
//           <span></span>
//           <span></span>
//           <span></span>
//         </button>
//         <div
//           className={`navmenu_wrapper ${isOpen ? 'active' : ''}`}
//           id="nav_wrapper"
//         >
//           {isOpen && (
//             <div
//               className="hidden_desk_overlay"
//               onClick={() => {
//                 setIsOpen(() => false)
//                 document.body.style.overflow = ''
//               }}
//             ></div>
//           )}
//           <ul ref={specificPartRef} className="navbar__items">
//             {isloaded && !user?.userId && (
//               <>
//                 <Link href="#." className="res_hidd" onClick={setShowModal}>
//                   <Image
//                     src={
//                       'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT40bKdGB_AF5LvkTHyvRaW3GqCZY7G2vLN30rm8Y5ubA&usqp=CAU&ec=48600112'
//                     }
//                     className="login_image"
//                     width={100}
//                     height={100}
//                     alt="image"
//                   />
//                 </Link>
//                 <MBtn
//                   buttonClass={'pv-toggle-close resimg_welclosebtn res_hidd'}
//                   withIcon
//                   iconClass={'closetoggle-icon'}
//                   onClick={() => {
//                     setIsOpen(() => false)
//                     document.body.style.overflow = ''
//                   }}
//                 />
//               </>
//             )}
//             {isloaded && user?.userId && (
//               <div>
//                 <ul className="res_hidd after_login_div">
//                   <li className="navbar__list li-f_fir">
//                     <Link
//                       className="navbar__link dropdown__icon"
//                       href="/user/profile"
//                     >
//                       <i className="m-icon m-after-login_icon"></i>
//                     </Link>
//                   </li>
//                   <li className="navbar__list li-s_sec">
//                     <Link
//                       className="navbar__link dropdown__icon"
//                       href="/user/profile"
//                     >
//                       {user?.fullName}
//                       <i className="m-icon menu-dropdown-icon"></i>
//                     </Link>
//                   </li>
//                   <MBtn
//                     buttonClass={'pv-toggle-close'}
//                     withIcon
//                     iconClass={'closetoggle-icon'}
//                     onClick={() => setIsOpen(false)}
//                   />
//                 </ul>
//               </div>
//             )}
//             {categoryMenu?.data?.length > 0 &&
//               categoryMenu?.data?.map((main, index) => (
//                 <li
//                   className={
//                     activeItems[index] && main?.subMenu?.length > 0
//                       ? 'navbar__list active'
//                       : 'navbar__list list-null'
//                   }
//                   key={main?.id}
//                   onMouseEnter={() => handleMouseEnter(index)}
//                   onMouseLeave={() => handleMouseLeave(index)}
//                   onClick={() => handleClick(index)}
//                 >
//                   <span className="navbar__link dropdown__icon">
//                     <Link
//                       href={checkMenuCase(main)}
//                       target={
//                         main?.redirectTo === 'Other Links' ? '_blank' : '_self'
//                       }
//                       onClick={() => {
//                         sendGAEvent({
//                           event: 'category_impression',
//                           value: main?.name
//                         })
//                         setIsOpen(false)
//                         document.body.style.overflow = ''
//                         setActiveSubmenus([])
//                         setActivethirdSubmenus([])
//                       }}
//                     >
//                       {main?.name}
//                     </Link>
//                     {main?.subMenu?.length > 0 && (
//                       <i
//                         className="m-icon menu-dropdown-icon"
//                         onClick={() => toggleSubmenu(index)}
//                       ></i>
//                     )}
//                   </span>

//                   <Masonry
//                     breakpointCols={breakpointColumnsObj}
//                     id={index}
//                     columnClassName={nav_linkimg ? `pv-imglinkset-col` : ' '}
//                     className={`navbar__submenu_div ${
//                       activeSubmenus?.includes(index) ? 'active' : ''
//                     }`}
//                   >
//                     {main?.subMenu?.map((item, index) => (
//                       <ul className="navbar__subitems" key={index}>
//                         <li className="navbar__sublist">
//                           <span className="navbar__sublink">
//                             <Link
//                               className="pv-navbarsub-link"
//                               href={checkMenuCase(item)}
//                               target={
//                                 item?.redirectTo === 'Other Links'
//                                   ? '_blank'
//                                   : '_self'
//                               }
//                               onClick={() => {
//                                 setIsOpen(false)
//                                 document.body.style.overflow = ''
//                                 setActiveSubmenus([])
//                                 setActivethirdSubmenus([])
//                               }}
//                             >
//                               {nav_linkimg && (
//                                 <Image
//                                   className="pv-navbar__sublinkimg"
//                                   src={encodeURI(
//                                     `${reactImageUrl}${_subMenuImg_}${item?.image}`
//                                   )}
//                                   alt={item?.imageAlt ?? 'image'}
//                                   width={100}
//                                   height={100}
//                                 />
//                               )}
//                               {item?.name}
//                             </Link>
//                             {item?.childMenu?.length > 0 && (
//                               <i
//                                 className="m-icon menu-dropdown-icon"
//                                 onClick={() => toggleThirdSubmenu(index)}
//                               ></i>
//                             )}
//                           </span>
//                           <div
//                             className={`navbar__submenu_sub_wrapper ${
//                               thirdSubmenus?.includes(index) ? 'active' : ''
//                             }`}
//                           >
//                             <ul className="navbar__subitems_sub">
//                               {item?.childMenu.map((item, subIndex) => (
//                                 <li
//                                   className="navbar__sublist_sub"
//                                   key={subIndex}
//                                 >
//                                   <Link
//                                     href={checkMenuCase(item)}
//                                     className="navbar__sublink_sub"
//                                     onClick={() => {
//                                       setIsOpen(false)
//                                       document.body.style.overflow = ''
//                                       setActiveSubmenus([])
//                                       setActivethirdSubmenus([])
//                                     }}
//                                     target={
//                                       item?.redirectTo === 'Other Links'
//                                         ? '_blank'
//                                         : '_self'
//                                     }
//                                   >
//                                     {item?.name}
//                                   </Link>
//                                 </li>
//                               ))}
//                             </ul>
//                           </div>
//                         </li>
//                       </ul>
//                     ))}
//                   </Masonry>
//                 </li>
//               ))}

//             <div className="res_hidd important_links-link">
//               <li className="navbar__list">
//                 <Link
//                   className="navbar__link dropdown__icon"
//                   href={
//                     isloaded && user?.userId ? '/user/orders?pi=1&ps=10' : '#.'
//                   }
//                   onClick={() => {
//                     setShowModal()
//                   }}
//                 >
//                   My Order
//                 </Link>
//               </li>
//               {isloaded && user?.userId && (
//                 <li className="navbar__list">
//                   <Link
//                     className="navbar__link dropdown__icon"
//                     href={user?.userId ? '/user/profile' : '#.'}
//                     onClick={() => {
//                       setShowModal()
//                     }}
//                   >
//                     <span>My Profile</span>
//                   </Link>
//                 </li>
//               )}
//               <li className="navbar__list">
//                 <Link
//                   className="navbar__link dropdown__icon"
//                   href={isloaded && user?.userId ? '/user/wishlist' : '#.'}
//                   onClick={() => {
//                     setShowModal()
//                   }}
//                 >
//                   Wishlist
//                 </Link>
//               </li>
//               <li className="navbar__list">
//                 <Link
//                   className="navbar__link dropdown__icon"
//                   href={isloaded && user?.userId ? '/user/address' : '#.'}
//                   onClick={() => {
//                     setShowModal()
//                   }}
//                 >
//                   My Addresses
//                 </Link>
//               </li>
//               {isloaded && user?.userId && (
//                 <li className="navbar__list">
//                   <button
//                     className="navbar__link dropdown__icon"
//                     onClick={() => {
//                       handleLogout(router, dispatch)
//                       setIsOpen(false)
//                     }}
//                   >
//                     Logout
//                   </button>
//                 </li>
//               )}
//             </div>
//           </ul>
//         </div>
//       </div>
//     </>
//   )
// }

// export default HeaderMenu
'use client'
import { spaceToDash } from '@/lib/GetBaseUrl'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import axiosProvider from '@/lib/AxiosProvider'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import LoginSignup from './auth/LoginSignup'

const HeaderMenu = ({ categoryMenu }) => {
  const { user } = useSelector((state) => state?.user)
  const [modal, setModal] = useState(false)
  const [isRmcOpen, setIsRmcOpen] = useState(false)
  const [bulkInquery, setBulkInquery] = useState(false)
  const [appointment, setAppointment] = useState(false)
  const [kitchen, setKitchen] = useState(false)
  const [wardrobe, setWardrobe] = useState(false)
  const router = useRouter()

  const checkMenuCase = async (card) => {
    let url = '#.'

    switch (card?.redirectTo) {
      case 'Product List':
        url = `/products/${spaceToDash(card?.name)}?CategoryId=${
          card?.categoryId
        }`
        if (card?.brands) {
          url += `&BrandIds=${card?.brands?.split(',')}`
        }
        if (card?.sizes) {
          url += `&SizeIds=${card?.sizes?.split(',')}`
        }
        if (card?.colors) {
          url += `&ColorIds=${card?.colors?.split(',')}`
        }
        break
      case 'Category List':
        url = '/category'
        break
      case 'Specific Category List':
        try {
          const res = await axiosProvider({
            method: 'GET',
            endpoint: `MainCategory/GetAllActiveCategory?Id=0&ParentId=${card?.categoryId}`
          })
          const categoryData = res?.data.data
          if (Array.isArray(categoryData) && categoryData.length > 0) {
            try {
              const res = await axiosProvider({
                method: 'GET',
                endpoint: `mainCategory/GetAllActiveCategory?Id=${card?.categoryId}`
              })
              const categoryDetails = res?.data?.data[0]
              if (
                categoryDetails?.parentId &&
                categoryDetails?.parentId !== null
              ) {
                url = `/category/${categoryDetails?.parentId}/SubCategory/${categoryDetails?.id}`
              } else {
                url = `/category/${spaceToDash(card?.name)}?CategoryId=${
                  card?.categoryId
                }`
              }
            } catch (error) {
              url = `/products/${spaceToDash(card?.name)}?CategoryId=${
                card?.categoryId
              }`
            }
            // url = `/category/${spaceToDash(card?.name)}?CategoryId=${
            //   card?.categoryId
            // }`
          } else {
            url = `/products/${spaceToDash(card?.name)}?CategoryId=${
              card?.categoryId
            }`
          }
        } catch (error) {
          url = `/products/${spaceToDash(card?.name)}?CategoryId=${
            card?.categoryId
          }`
        }
        break

      case 'Collection Page':
        url = `/collection?productCollectionId=${card?.collectionId}`
        break

      case 'Brand List':
        url = `/brands`
        break

      case 'Static Page':
        url = `/staticPage?id=${card?.staticPageId}`
        break

      case 'Landing Page':
        url = `/landing/${spaceToDash(card?.name)}/${card?.lendingPageId}`
        break
      case 'Kitchen Inquiry':
        url = handleLogin(card?.redirectTo)
        break
      case 'Wardrobe Inquiry':
        url = handleLogin(card?.redirectTo)
        break

      case 'Custom link':
        url = card?.customLink?.startsWith('http')
          ? card.customLink
          : card?.customLink || '#.'
        break
      case 'Door Inquiry':
        url = handleLogin(card?.redirectTo)
        break
      case 'Windows Inquiry':
        url = handleLogin(card?.redirectTo)
        break

      case 'Specification list':
        url = `/specifcations/${card?.specValueId}`
        break

      case 'Specific Brand List':
        url = `/brands/${card?.brandId}`
        break

      case 'RMC Inquiry':
        handleLogin(card?.redirectTo)
        return null

      case 'Bulk Inquiry':
        handleLogin(card?.redirectTo)
        return null
      case 'Book Appointment':
        handleLogin(card?.redirectTo)
        return null
      case 'Kitchen Appointment':
        handleLogin(card?.redirectTo)
        return null

      case 'Wardrobe Appointment':
        handleLogin(card?.redirectTo)
        return null
      case 'Design Services':
        url = handleLogin(card?.redirectTo)
        return
      case 'Credit Services':
        url = `creditservices`
        break
      default:
        url = '#.'
        break
    }

    return url
  }
  const handleLogin = (inquiry) => {
    if (!user?.userId) {
      setModal(true)
    } else {
      if (inquiry === 'RMC Inquiry') {
        setIsRmcOpen(true)
      } else if (inquiry === 'Door Inquiry') {
        return '/inquiry/door'
      } else if (inquiry === 'Windows Inquiry') {
        return '/inquiry/window'
      } else if (inquiry === 'Kitchen Inquiry') {
        return `/kitchenInquiry/kitchen?_=${Date.now()}`
      } else if (inquiry === 'Wardrobe Inquiry') {
        return '/kitchenInquiry/wardrobe'
      } else if (inquiry === 'Book Appointment') {
        setAppointment(true)
      } else if (inquiry === 'Kitchen Appointment') {
        setKitchen(true)
      } else if (inquiry === 'Wardrobe Appointment') {
        setWardrobe(true)
      } else if (inquiry === 'Design Services') {
        return `/services`
      } else {
        setBulkInquery(true)
      }
    }
  }

  const handleNavigation = async (card) => {
    const finalUrl = await checkMenuCase(card)
    router.push(finalUrl)
  }

  return (
    <div className="w-full bg-primary">
      {isRmcOpen && <RmcInquiryModal onClose={() => setIsRmcOpen(false)} />}
      {bulkInquery && (
        <BulkInquery open={bulkInquery} onClose={() => setBulkInquery(false)} />
      )}
      {appointment && (
        <AppointmentModal onClose={() => setAppointment(false)} />
      )}
      {kitchen && (
        <AppointmentModal
          onClose={() => setKitchen(false)}
          appointmentFor={'Kitchen'}
        />
      )}
      {wardrobe && (
        <AppointmentModal
          onClose={() => setWardrobe(false)}
          appointmentFor={'Wardrobe'}
        />
      )}
      {modal && <LoginSignup onClose={() => setModal(false)} />}
      <div className="site-container">
        <ul className="flex items-center justify-start gap-6 scrollbar-hide whitespace-nowrap overflow-x-auto group">
          {categoryMenu?.data?.length > 0 &&
            categoryMenu?.data
              ?.sort((a, b) => {
                const seqA = a?.sequence || 0
                const seqB = b?.sequence || 0
                return seqA - seqB
              })
              ?.map((main, index) => (
                <li className="inline-flex py-2 list-none" key={main?.id}>
                  <button
                    type="button"
                    onClick={() => {
                      // sendGAEvent({
                      //   event: 'category_impression',
                      //   value: main?.name
                      // })
                      handleNavigation(main) // ✅ handles async API & redirects
                    }}
                    className="font-medium text-[0.9375rem] capitalize transition-colors duration-200 text-white/90 hover:text-white"
                  >
                    {main?.name}
                  </button>
                </li>
              ))}
        </ul>
      </div>
    </div>
  )
}

export default HeaderMenu
